import EditorViewState from '../store/schema/EditorViewState';
import setIsDirty from '../actions/setIsDirty';
import updateContent from '../actions/updateContent';
import { Editor, EditorPlugin } from 'roosterjs-editor-core';
import { PluginEvent, PluginEventType } from 'roosterjs-editor-types';

export default class ViewStateManagePlugin implements EditorPlugin {
    private editor: Editor;

    constructor(private viewState: EditorViewState, private updateOnKeyPress: boolean) {}

    getName() {
        return 'ViewStateManage';
    }

    initialize(editor: Editor) {
        this.editor = editor;
    }

    dispose() {
        this.editor = null;
    }

    onPluginEvent(e: PluginEvent) {
        if (e.eventType == PluginEventType.Input) {
            if (this.updateOnKeyPress) {
                this.updateContentToViewState();
            } else if (!this.viewState.isDirty) {
                setIsDirty(this.viewState, true /*isDirty*/);
            }
        }
    }

    updateContentToViewState(isInitializing?: boolean) {
        if (this.editor) {
            updateContent(this.viewState, this.editor.getContent(), isInitializing);
        }
    }
}
